import { useState } from 'react';

export const FormFlow = ({ recipientLogin, children }) => {
  const [isFetching, setIsFetching] = useState(false);

  const onSubmit = async (formData) => {
    try {
      setIsFetching(true);
      await recipientLogin({ dataForRecipientLogin: formData });
    } catch (error) {
      setIsFetching(false);
    }
  };

  return children({
    onSubmit,
    isFetching,
  });
};

export default FormFlow;
